export default __webpack_public_path__ + "static/media/banner_coins.97f19da0.svg";